import React, { Dispatch, SetStateAction, useCallback, useState } from 'react';

import { Decision } from '../../../../common/constants/decision';
import { IDecision } from '../../interfaces/IDecision';
import EditWaive from './EditWaive';
import { ReviewWaive } from './ReviewWaive';
import { WaiveFormData } from './useWaiveForm';

export const WaiveDrawer = ({
  isOpen,
  setIsOpen,
  applicationId,
  editedDecision,
  onDecisionChanged,
  isEditLeadingToCLR,
}: {
  isOpen: boolean;
  setIsOpen: Dispatch<SetStateAction<boolean>>;
  applicationId: string;
  editedDecision?: IDecision;
  onDecisionChanged?: (decision: Decision) => void;
  isEditLeadingToCLR?: boolean;
}) => {
  const [formData, setFormData] = useState<WaiveFormData | null>(null);
  const [isReview, setIsReview] = useState(false);

  const onEditSuccess = useCallback((data: WaiveFormData) => {
    setFormData(data);
    setIsReview(true);
  }, []);

  return (
    <>
      {isReview && formData && (
        <ReviewWaive
          applicationId={applicationId}
          isOpen={isOpen}
          setIsOpen={setIsOpen}
          setIsReview={setIsReview}
          description={formData.description}
          editedDecision={editedDecision}
          formData={formData}
          isEditLeadingToCLR={isEditLeadingToCLR}
        />
      )}
      {!isReview && (
        <EditWaive
          onSuccess={onEditSuccess}
          initialFormData={formData}
          isOpen={isOpen}
          setIsOpen={setIsOpen}
          isUpdate={!!editedDecision}
          onDecisionChanged={onDecisionChanged}
        />
      )}
    </>
  );
};
